import { render, staticRenderFns } from "./ImageHeader.vue?vue&type=template&id=e5252f74&scoped=true&"
import script from "./ImageHeader.vue?vue&type=script&lang=js&"
export * from "./ImageHeader.vue?vue&type=script&lang=js&"
import style0 from "./ImageHeader.vue?vue&type=style&index=0&id=e5252f74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5252f74",
  null
  
)

export default component.exports